import { AccountApi } from "../../Types/Generated/LogbookApi/AccountApi"
import type { IAccountUser } from "../../Types/Generated/LogbookModel/AccountUser"
import { entity, type StoredAccountUser } from "./Connection"

type AccountUserProjection =
  & Pick<IAccountUser, "accountId" | "userId" | "accountLevel">
  & Partial<Omit<IAccountUser, "accountId" | "userId" | "accountLevel">>;

export function normalizeAccountUser(user: AccountUserProjection): StoredAccountUser {
  return { ...user, id: user.userId };
}

export const AccountUserEntity = entity("AccountUser", {
  fetch: (client, { accountId }) => {
    if (accountId === undefined) {
      return Promise.reject(new Error("AccountUser fetch requires accountId"));
    }
    return new AccountApi(client).account.users({ params: {} }).call().then((response) => {
      const accountUserInfo = Object.fromEntries(response.users.map((info) => [
        info.user.id,
        { status: info.status, hasShipAccess: info.hasShipAccess },
      ]));
      return {
        entities: {
          AccountUser: response.users.map((info) => normalizeAccountUser({
            accountId,
            userId: info.user.id,
            accountLevel: info.level,
          })),
          User: response.users.map((info) => ({ ...info.user, accountId: info.user.accountId ?? accountId })),
        },
        extras: { accountUserInfo },
        partial: ["AccountUser", "User"] as const,
        authoritative: {
          AccountUser: { accountId },
          User: { accountId },
        },
      };
    });
  },
  normalize: normalizeAccountUser,
});
